import {ApplicationConfig, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer,} from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { LanguageService } from './services/language.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import {Language} from "./common/languages.config";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        }
      })
    ),
    provideNgxMask(),
    provideAppInitializer(() => {
      const languageService = inject(LanguageService);
      return languageService.initAsync();
    }),
    {
      provide: LOCALE_ID,
      useFactory: (lang: LanguageService) =>
        lang.currentLanguage() === Language.HR ? 'hr' : 'en-US',
      deps: [LanguageService]
    }
  ]
};
